import { Reducer } from 'redux';
import { IAction, IAuthState } from 'src/interface';
import { ACTIONS } from '../actions/auth/dispatchActions';

const defaultState: IAuthState = {
    isFetching: true,
    userId: 0,
    strUserId: '',
    displayName: '',
    avatar: 'https://avatar.talk.zdn.vn/default.jpg',
};

const authReducer: Reducer<IAuthState, IAction<any>> = (
    state = defaultState,
    action: IAction<any>
) => {
    const { type, payload } = action;

    switch (type) {
        case ACTIONS.AUTH_SET_STATE:
            return {
                ...state,
                ...defaultState,
                ...payload,
            };
        case ACTIONS.AUTH_CLEAR_STATE:
            return {
                ...defaultState,
            };
        case ACTIONS.AUTH_IS_FETCHING_UPDATE:
            return {
                ...state,
                isFetching: payload,
            };

        default:
            return state;
    }
};

export default authReducer;
